import React, { useState } from 'react'
import { useEffect } from 'react';
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import { listReservationsHistoryFetchState, reservationsHistoryState } from 'src/Patient/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { userState } from 'src/store/user/userState';
import { activeTabReservationsPatientState } from '../state/atoms';
import CardReservation from './CardReservation'

const ListHistoryReservations = () => {
    const { catchErrorApi } = useCatchErrorApi();
    const user = useRecoilValue(userState);
    const [reservationsHistory, setReservationsHistory] = useRecoilState(reservationsHistoryState);
    const [loading, setLoading] = useState(false)
    const activeTabReservationsPatient = useRecoilValue(activeTabReservationsPatientState);

    const reservationsHistoryCallback = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        try {
            if (activeTabReservationsPatient === "2") {
                const reservationsFetch = await snapshot.getPromise(listReservationsHistoryFetchState(user.payload.uswRut));
                setReservationsHistory(reservationsFetch)
            }

        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false)
        }
    }, [activeTabReservationsPatient]);

    useEffect(() => {
        reservationsHistoryCallback()

        // return () => {
        //     reservationsHistoryCallback()
        // }
    }, [reservationsHistoryCallback])

    if (loading) return <HoursAvailableSkeleton />
    if (!loading && reservationsHistory && reservationsHistory.length === 0) return <EmptyCalendar text={"No tienes reservas registradas"} />

    return (
        <div>
            {
                reservationsHistory.map((el, index) => (
                    <CardReservation cancelReservation={false} key={`${el.ptdRut}_${index}`} professional={el} />
                ))
            }
        </div>
    )
}

export default ListHistoryReservations
